import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Box, Button, Card, CardContent, Grid, TextField } from '@mui/material';
import { v4 as uuid } from 'uuid';

const NewShoppingListGroupForm = ({ onAdd, onCancel }) => {
  const [groupName, setGroupName] = useState('');

  const onClickAdd = () => {
    const id = uuid();
    onAdd({ id, title: groupName, disallowAddingCard: true });
  };

  const onKeyDown = (event) => {
    if (event.keyCode === 13) {
      onClickAdd();
    }
    if (event.keyCode === 27) {
      onCancel();
    }
    return null;
  };

  return (
    <Card sx={{ width: 250, marginTop: '5px' }}>
      <CardContent>
        <Grid container>
          <Grid item xs={12} style={{ marginBottom: '6px' }}>
            <TextField
              fullWidth
              autoFocus
              label="Group name"
              placeholder="e.g. 'From Tesco'"
              variant="outlined"
              value={groupName}
              size="small"
              onChange={(ev) => setGroupName(ev.target.value)}
              onKeyDown={onKeyDown}
            />
          </Grid>
          <Grid item xs={6}>
            <Button
              onClick={onClickAdd}
              variant="contained"
              size="small"
              color="primary"
              disabled={groupName.length === 0}>
              Add
            </Button>
          </Grid>
          <Grid item xs={6}>
            <Box display="flex" justifyContent="flex-end">
              <Button
                onClick={onCancel}
                variant="contained"
                size="small"
                color="secondary">
                Cancel
              </Button>
            </Box>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

NewShoppingListGroupForm.propTypes = {
  onCancel: PropTypes.func.isRequired,
  onAdd: PropTypes.func.isRequired,
};

export default NewShoppingListGroupForm;
